import { jsx as _jsx } from "react/jsx-runtime";
import { SearchResultBlock, SearchResultsNothingFound, isUserAgentAppleMobilePlatform } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Box, Menu } from '@yonderland/andes-react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { bannerIds, blockTitles, NOTHING_FOUND_SESSION_KEY } from '../../../constants/SearchConstants';
import { useMenuSearch } from '../../../hooks/useMenuSearch';
import { useVirtualKeyboard } from '../../../hooks/useVirtualKeyboard';
import { searchActions } from '../../../redux/search/actions/SearchActions.creators';
import { hasItems } from '../../../util/ArrayUtil';
import { appendSearchQueryToUrl, getKeywordsSuggestionsUrl } from '../../../util/SearchUtil';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
export const MobileNavigationSearch = ({ brandsParentLink, categoriesParentLink, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    const dispatch = useDispatch();
    const { root } = useAemConfig();
    const listerPageUrl = `${root}lister.html`;
    const [searchTerm, setSearchTerm] = useState('');
    const searchBarInputRef = useRef(null);
    const virtualKeyboardHeight = useVirtualKeyboard();
    const { menuSearchItemGrouping } = useMenuSearch({
        searchTerm,
        brandsParentLink,
        categoriesParentLink,
        suggestionsParentLink: root,
    });
    const hasSearchResults = !!menuSearchItemGrouping && hasItems(Object.keys(menuSearchItemGrouping));
    const handleSearchSubmit = (value) => {
        if (value.length === 0)
            return;
        dispatch(searchActions.createAdobeAnalyticsSetSearchTermAction(value));
        window.location.href = getKeywordsSuggestionsUrl(root, searchTerm);
    };
    const handleSearchValueChange = (value, byKeyDown) => {
        setSearchTerm(value);
        byKeyDown && handleSearchSubmit(value);
    };
    const handleSearchItemClick = (value) => {
        var _a;
        setSearchTerm(`${value} `);
        (_a = searchBarInputRef === null || searchBarInputRef === void 0 ? void 0 : searchBarInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    return (_jsx(Menu.Search, { placeholder: t('flyout.search.placeholder'), value: searchTerm, onChange: handleSearchValueChange, searchBarInputRef: searchBarInputRef, children: searchTerm ? (hasSearchResults ? (_jsx("div", { style: isUserAgentAppleMobilePlatform() && virtualKeyboardHeight
                ? { marginBottom: virtualKeyboardHeight }
                : undefined, children: Object.values(menuSearchItemGrouping).map(menuSearchItemGroup => (_jsx(SearchResultBlock, { analyticsAreaName: bannerIds[menuSearchItemGroup.type], highlightValue: searchTerm, items: menuSearchItemGroup.items, onItemSuggestionFillClick: handleSearchItemClick, showSuggestionFill: menuSearchItemGroup.enableSuggestionFill, showTextSubtle: menuSearchItemGroup.showTextSubtle, title: t(blockTitles[menuSearchItemGroup.type]) }, menuSearchItemGroup.type))) })) : (_jsx(Box, { paddingBlockStart: "4", children: _jsx(SearchResultsNothingFound, { analyticsAreaName: "mobile-nav-search-zero-suggest", searchValue: searchTerm, url: appendSearchQueryToUrl(listerPageUrl, searchTerm), onClick: () => SessionStorageUtil.setItem(NOTHING_FOUND_SESSION_KEY, '1'), translations: { noResults: t('flyout.no.search.results') } }) }))) : null }));
};
